/**
 * SAP CONFIDENTIAL 
 *
 * This software is confidential proprietary software licensed by SAP SE 
 * and is not to be used, duplicated or disclosed to anyone without the 
 * prior written permission of SAP. 
 *
 * (C) 2020 Copyright SAP SE.
 */
import { Component, OnInit, ViewChildren, Output, EventEmitter, QueryList, Input, ViewEncapsulation } from '@angular/core';
import { PopoverDirective } from 'ngx-bootstrap/popover';
import { SortByPipe } from '../pipes/sorting';
import { CommonService } from '../services/common.service';
import { AvailbleBSPositions } from 'ngx-bootstrap/positioning';

@Component({
  selector: 'app-report-tags',
  templateUrl: './report-tags.component.html',
  styleUrls: ['./report-tags.component.scss'],
  providers: [SortByPipe],
  encapsulation: ViewEncapsulation.None
})

export class ReportTagsComponent implements OnInit {
  @Output() loadSelectedReportEvt = new EventEmitter();
  @Output() getAllSavedReportsEvt = new EventEmitter();
  @Output() shareMyReportEvent = new EventEmitter();
  @Output() deleteMyReportEvent = new EventEmitter();
  @Input() savedReports: Array<any> = [];
  @Input() reportName = '';
  @Input() shareReportAccess = false;
  @ViewChildren(PopoverDirective) popovers!: QueryList<PopoverDirective>;
  public searchByReportName: any;
  public searchByAuthorName: any;
  public searchByReportDate: any;
  public headerObj: any = [];
  public userTagsList: any = [];
  public reportTagItems: any = [];
  public selReportTag: any;
  public selTagTab: any;
  public userManageTagsList: any;
  public existingUserManageTagsList: any = [];
  public existingReportTags: any = [];
  public popoverPosition: AvailbleBSPositions;

  constructor(private sortByPipe: SortByPipe,
    private commonService: CommonService
  ) {
    this.popoverPosition = (window.innerWidth > 767 && window.innerHeight > 700) ? 'bottom' : 'right';
  }

  ngOnInit() {
    this.getUserTags();

    this.headerObj = [{
      fieldName: 'name',
      isDesc: false,
      show: false
    }, {
      fieldName: 'createdBy',
      isDesc: false,
      show: false
    }, {
      fieldName: 'createdDate',
      isDesc: false,
      show: false
    }];
  }

  public getTranslationWithKey(key: string): string {
    return this.commonService.getTranslatedVal(key);
  }

  public searchInputClicked(event: any) {
    event.stopPropagation();
  }

  public loadSelectedReport(report: any, data: any, dropdown: any) {
    dropdown.hide();
    this.loadSelectedReportEvt.emit({ report, data });
  }

  public addTagToReport(report: any, pop: any) {
    let useTag = false;
    const vm = this, userTagsList = JSON.parse(JSON.stringify(this.userTagsList));
    this.popovers.forEach((popover: PopoverDirective) => {
      popover.hide();
    });
    this.reportTagItems = JSON.parse(JSON.stringify(report.reportTags));
    this.existingReportTags = JSON.parse(JSON.stringify(report.reportTags));
    this.selReportTag = report;
    this.selReportTag.availReportTags = [];
    userTagsList.forEach(function (userTag: any) {
      useTag = false;
      vm.selReportTag.reportTags.forEach(function (selTag: any) {
        if (userTag.name === selTag.name) {
          useTag = true;
        }
      });
      if (!useTag) {
        vm.selReportTag.availReportTags.push(userTag);
      }
    });
    pop.show();
  }

  public saveReportTags(event: any) {
    this.reportTagItems = this.reportTagItems.map((item: any) => ({ name: item }));
    const saveReport = JSON.parse(JSON.stringify(this.reportTagItems)),
      selRepObj: any = {};
    selRepObj.id = this.selReportTag.id;

    event.stopPropagation();
    this.popovers.forEach((popover: PopoverDirective) => {
      popover.hide();
    });
    saveReport.forEach(function (reportTag: any) {
      reportTag.userReport = selRepObj;
      if (reportTag.id) {
        reportTag.operation = 'Update';
      } else {
        reportTag.operation = 'Create';
      }
    });
    if (this.selReportTag.delTags) {
      this.selReportTag.delTags.forEach(function (delTag: any) {
        delTag.userReport = selRepObj;
        delTag.operation = 'Remove';
        saveReport.push(delTag);
      });
    }
    this.commonService.saveReportTags(saveReport).then(this.saveReportTagsSH.bind(this), (reason) =>this.commonService.commonErrorHandler(reason));
  }

  private saveReportTagsSH(res: any) {
    const resp = res,
      results = resp.hasOwnProperty('length') === true ? resp : resp.data;
    this.selReportTag = '';
    if (results.length) {
      this.getAllSavedReportsEvt.emit();
      this.getUserTags();
    }
  }

  public getUserTags() {
    this.commonService.getAllReportTags().then(this.getUserTagsSH.bind(this), (reason) =>this.commonService.commonErrorHandler(reason));
  }

  private getUserTagsSH(res: any) {
    const resp = res,
      results = resp.hasOwnProperty('length') === true ? resp : resp.data;
    this.userTagsList = results;
    this.userManageTagsList = results;
    this.existingUserManageTagsList = results;
  }

  public addExistTagToReport(tag: any) {
    this.reportTagItems.push(tag);
    if (this.selReportTag.delTags) {
      this.selReportTag.delTags = this.selReportTag.delTags.filter(function (delTag: any) {
        return tag.name !== delTag.name;
      })
    }
    this.selReportTag.availReportTags = this.selReportTag.availReportTags.filter(function (availTag: any) {
      return availTag.name !== tag.name;
    })
  }

  public onItemAdded(event: any) {
    let vm = this, brkStmt = false;
    if (event && event.value) {
      this.userManageTagsList.forEach(function (userManageTag: any) {
        if (userManageTag.value == event.value && !brkStmt) {
          vm.reportTagItems.pop();
          brkStmt = true;
        }
      })
    }
  }

  public onItemRemoved(event: any) {
    if (event && event.id) {
      this.selReportTag.availReportTags.push(event);
      if (!this.selReportTag.delTags) {
        this.selReportTag.delTags = [];
      }
      if (event.id) {
        this.selReportTag.delTags.push(event);
      }
    }
  }

  public manageTags(popManage: any) {
    this.existingUserManageTagsList = JSON.parse(JSON.stringify(this.userManageTagsList));
    popManage.show();
  }

  public closeManageTag(event: any, popManage?: any) {
    event.stopPropagation();
    this.userManageTagsList = JSON.parse(JSON.stringify(this.existingUserManageTagsList));
    this.popovers.forEach((popover: PopoverDirective) => {
      popover.hide();
    });
  } 

  public closeReportTags(event: any, pop: any, report: any) {
    report.reportTags = JSON.parse(JSON.stringify(this.existingReportTags));
    event.stopPropagation();
    pop.hide();
  }

  public removeManageTag(event: any, tag: any) {
    event.stopPropagation();
    this.userManageTagsList.forEach(function (userTag: any) {
      if (tag.name === userTag.name) {
        userTag.operation = 'Delete';
      }
    })
  }

  public saveManageTags(event: any) {
    event.stopPropagation();
    this.popovers.forEach((popover: PopoverDirective) => {
      popover.hide();
    });
    const delUserManageTagList = this.userManageTagsList.filter(function (userTag: any) {
      return userTag.operation === 'Delete';
    });
    if (delUserManageTagList && delUserManageTagList.length > 0) {
      this.commonService.saveReportTags(delUserManageTagList)
        .then(this.saveReportManageTagsSH.bind(this), (reason) =>this.commonService.commonErrorHandler(reason));
    }
  }

  private saveReportManageTagsSH() {
    this.getAllSavedReportsEvt.emit();
    this.getUserTags();
  }

  public selReportTagTab(tag: any) {
    if (tag.name == this.selTagTab) {
      this.selTagTab = '';
    } else {
      this.selTagTab = tag.name;
    }
  }

  public shareMyReport(report: any) {
    this.shareMyReportEvent.emit(report);
  }

  public deleteMyReport(report: any) {
    this.deleteMyReportEvent.emit(report);
  }

  public doSorting(columnIndex: any, predefinedSortingOrder?: any, returnValue?: any) {
    const column = this.headerObj[columnIndex],
      fieldName = column.fieldName;
    let sortingOrder;
    for (let header = 0; header < this.headerObj.length; header++) {
      if (header == columnIndex) {
        this.headerObj[header].show = true;
      } else {
        this.headerObj[header].show = false;
      }
    }
    if (predefinedSortingOrder) {
      if (column.isDesc) {
        sortingOrder = true;
      } else {        
        sortingOrder = false;
      }
    } else {
      column.isDesc = !column.isDesc;
      sortingOrder = column.isDesc;
    }
    if (returnValue) {
      return this.sortByPipe.transform(this.savedReports, { field: fieldName, isDesc: sortingOrder });
    } else {
      this.savedReports = this.sortByPipe.transform(this.savedReports, { field: fieldName, isDesc: sortingOrder });
    }
  }
}
